/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2023 - 2023
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { useDispatch, useSelector } from "react-redux";

import messages from "../../../helpers/messages";
import {
  resetBannerActionState,
  setCapacityMatchStatus
} from "../../../slices/bidProcurementSlice";
import {
  status as bidStatus,
  capacityMatchingStatus,
  mode
} from "../../../helpers/types";
import ErrorMessage from "./ErrorMessage";
import SpinnerButton from "./SpinnerButton";
import AccessTimeIcon from "../../icons/AccessTimeIcon";

function CarrierRepViewReviewState({ role, summary }) {
  const dispatch = useDispatch();
  const {
    updateCapacityMatchStatusIsLoading,
    updateCapacityMatchStatusFailure
  } = useSelector(state => state.bidProcurement);

  const { modes, bidId } = summary;
  const { bidModeId } = modes.find(
    x =>
      x.mode === mode.tl &&
      x.status === bidStatus.inProgress &&
      x.capacityMatchingStatus === capacityMatchingStatus.review
  );

  const handleEditMatches = () => {
    dispatch(resetBannerActionState());
    dispatch(
      setCapacityMatchStatus(
        bidId,
        bidModeId,
        capacityMatchingStatus.inProgress,
        true,
        role
      )
    );
  };

  return (
    <>
      <p className="inline-block font-size-14 pt-16 mb-0">
        {updateCapacityMatchStatusFailure ? (
          <ErrorMessage />
        ) : (
          messages.carrierRepViewReviewBannerMessage.defaultMessage
        )}
      </p>
      <div className="fr py-8 my-2">
        {updateCapacityMatchStatusIsLoading ? (
          <SpinnerButton minWidth="120px" />
        ) : (
          <button
            className="text-button univers-67-bold-cond font-size-14 mx-8 h-32 border-cobalt-blue"
            data-testid="edit-matches"
            onClick={() => handleEditMatches(bidModeId, bidId)}
            style={{ minWidth: "120px" }}
          >
            {messages.editMatches.defaultMessage}
          </button>
        )}
        <div
          className="fr pt-8 inline-block mb-0 weight--semibold mx-8"
          id="pending-final-review"
        >
          <AccessTimeIcon
            className="align-text-bottom mr-8"
            height={12}
            width={12}
            fill="#000000"
          />
          {messages.pendingFinalReview.defaultMessage}
        </div>
      </div>
    </>
  );
}

export default CarrierRepViewReviewState;
